<div class="footer-row on-hold">
  <app-footer-info [task]="task" [statusText]="statusText"></app-footer-info>
  <div class="on-hold-actions">
    <button class="action-btn retrieve" [disabled]="actionsDisabled$ | async" (click)="onRetrieve()">
      <i [nimbusIcon]="ICONS.CALLBACK" [iconWeight]="IconWeight.Regular"></i>
      <span class="action-text">{{ TranslationKeys.AssistantSessionFooterActionsRetrieve | translate }}</span>
    </button>
    <button class="action-btn terminate" [disabled]="actionsDisabled$ | async" (click)="onTerminateCall()">
      <i [nimbusIcon]="ICONS.DECLINE" [iconWeight]="IconWeight.Regular"></i>
      <span class="action-text">{{ TranslationKeys.AssistantSessionFooterActionsHangup | translate }}</span>
    </button>
  </div>
</div>
